function LoadMore() {
	return `
		<div class="results-show-more flex w-full mt-5" style="width:100%">
			<div class="btn btn-outline-alt w-full">
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g id="plus">
					<path id="Union" fill-rule="evenodd" clip-rule="evenodd" d="M12.5 17.7C15.9242 17.7 18.7 14.9242 18.7 11.5C18.7 8.07583 15.9242 5.3 12.5 5.3C9.07583 5.3 6.3 8.07583 6.3 11.5C6.3 14.9242 9.07583 17.7 12.5 17.7ZM12.5 19C16.6421 19 20 15.6421 20 11.5C20 7.35786 16.6421 4 12.5 4C8.35786 4 5 7.35786 5 11.5C5 15.6421 8.35786 19 12.5 19ZM12 8H13.3V11H16V12.3H13.3V15H12V12.3H9V11H12V8Z" fill="#191919"></path>
				</g>
			</svg>
				Show More
			</div>
		</div>
	`
}

export default LoadMore;